import { Component } from '@angular/core';
import { EnfermeraService } from 'src/app/services/enfermera.service';
import { Enfermera } from 'src/app/models/enfermera.interface';
import { Producto } from 'src/app/models/producto.interface';
import { AuthService } from 'src/app/services/auth.service';
import { Paginar } from 'src/app/models/http-paginacion.interface';
@Component({
  selector: 'app-enfermera-productos',
  templateUrl: './enfermera-productos.component.html',
  styleUrls: ['./enfermera-productos.component.scss']
})
export class EnfermeraProductosComponent {
  enfermera!: Enfermera;
  productos: Producto[] = [];

  currentPageProductos: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItemsProductos: number = 10;

  get Productos(): Producto[] {
    const startIndex = (this.currentPageProductos.page) * this.currentPageProductos.rows;
    return this.productos.slice(startIndex, startIndex + this.currentPageProductos.rows);
  }
  get totalPaginasProductos(): number {
    return Math.ceil(this.productos.length / this.currentPageProductos.rows);
  }
  constructor(private EnfermeraService: EnfermeraService, private authService: AuthService) {

    if (this.authService.isLoggedIn) {
      const idEnfermera: number | undefined = this.authService.getUsuario?.enfermera?.id;
      if (idEnfermera) this.obtenerInformacion(idEnfermera);
    }

  }
  obtenerInformacion(id: number): void {
    this.EnfermeraService.getEnfermera(id).subscribe({
      next: (resp) => {
        this.productos = resp.datos.productos;
        this.enfermera = resp.datos;
        this.totalItemsProductos = this.productos.length;
        //console.log(resp)
      },
      error: (err) => console.log(err)
    });
  }
  onPageChangeProductos(event: any) {
    this.currentPageProductos = <Paginar>event;
  }
}
